import { render, staticRenderFns } from "./CheckTemplate.vue?vue&type=template&id=73b273c4"
import script from "./CheckTemplate.vue?vue&type=script&lang=js"
export * from "./CheckTemplate.vue?vue&type=script&lang=js"
import style0 from "./CheckTemplate.vue?vue&type=style&index=0&id=73b273c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports